import axios from 'axios';

class UserService {
    async getProfile() {
        const response = await axios.get('/api/users/me');
        return response.data;
    }

    async updateProfile(firstName, lastName) {
        const response = await axios.put('/api/users/me', { firstName, lastName });
        return response.data;
    }

    async uploadAvatar(file) {
        const formData = new FormData();
        formData.append('avatar', file);

        const response = await axios.post('/api/users/me/avatar', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    }

    async deleteAvatar() {
        const response = await axios.delete('/api/users/me/avatar');
        return response.data;
    }


    async updatePassword(currentPassword, newPassword) {
        const response = await axios.put('/api/users/me/password', { currentPassword, newPassword });
        return response.data;
    }

    async endTrial() {
        const response = await axios.post('/api/payment/end-trial');
        return response.data;
    }

    async cancelSubscription() {
        const response = await axios.post('/api/payment/cancel-subscription');
        return response.data;
    }
}

const userService = new UserService();
export default userService;
